import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { Button, ErrorTemplate } from 'next-common-lib';
import i18n from 'i18n';
import { getLanguage } from 'utils/cookies';
import { TERMS_TYPE } from 'constants/IncorporationConstants';
import AccountRegister from 'components/IncorporationOfTerms/Register/FormOrganism/AccountRegister';
import * as instantsActions from 'redux/ducks/Employee/InstantDucks';
import InstantRegister from './Register/FormOrganism/InstantRegister';
import InviteRegister from './Register/FormOrganism/InviteRegister';
import ReAgreement from './Register/FormOrganism/ReAgreement';
import PageHeader from './Register/FormAtoms/PageHeader';
import Compltion from './Compltion';
import BrityHeader from './Register/FormAtoms/BrityHeader';
import BrityFooter from './Register/FormAtoms/BrityFooter';

export const IncorporationOfTerms = () => {
  const dispatch = useDispatch();
  const termsIsSuccess = useSelector(state => state.terms.isSuccess);
  const inviteChange = useSelector(state => state.invitation.isCreateAccount);
  const adminCreate = useSelector(state => state.employee.isCreateAccount);
  const instantCreate = useSelector(state => state.instant.isCreateAccount);
  const { employeeVo } = useSelector(state => state.instant);
  let titleSvcType = 'PT';
  const location = useLocation();
  const { menu } = useParams();
  const sch = location.search;
  const searchParams = new URLSearchParams(sch);
  const svcType = searchParams.get('svcType');
  const langCd = getLanguage();
  const submitButton = useRef(null);
  const [isFormValid, setFormValid] = useState(false);
  const [isLoad, setIsLoad] = useState(false);

  const handleValidationChange = isValid => {
    setFormValid(isValid);
  };
  const termsHandleSave = () => {
    submitButton.current.submit();
  };

  useEffect(() => {
    if (menu === 'reagreement') {
      dispatch(instantsActions.getLoginUser({}));
    }
    if (menu === 'admin') {
      if (window.top !== window.self) {
        window.top.location = window.self.location;
      }
    }
    setIsLoad(true);
  }, [menu]);

  const makeComponent = () => {
    let getComponent = '';

    switch (menu) {
      case 'account':
        // PT 신규가입 :menu account
        getComponent = <AccountRegister ref={submitButton} onValidationChange={handleValidationChange} />;
        break;
      case 'instant':
        // 즉시 발급 신규가입 :menu instant
        // 신규계정 가입하기
        titleSvcType = 'instant';
        getComponent = (
          <InstantRegister langCd={langCd} ref={submitButton} onValidationChange={handleValidationChange} />
        );
        break;
      case 'invitation':
        // 초대링크 신규가입 :menu invitation
        titleSvcType = 'invitation';
        getComponent = (
          <InviteRegister langCd={langCd} ref={submitButton} onValidationChange={handleValidationChange} />
        );
        break;
      case 'reagreement':
        // 재동의 :menu reagreement
        titleSvcType = employeeVo?.pslInfoAgmtYn === 'N' ? TERMS_TYPE.REAGREEMENT : TERMS_TYPE.AGREEMENT;
        getComponent = (
          <ReAgreement
            svcType={employeeVo?.pslInfoAgmtYn === 'N' ? TERMS_TYPE.REAGREEMENT : TERMS_TYPE.AGREEMENT}
            ref={submitButton}
            onValidationChange={handleValidationChange}
          />
        );
        break;
      case 'agreement':
        // 즉시발급 동의 :menu agreement
        titleSvcType = TERMS_TYPE.AGREEMENT;
        getComponent = (
          <ReAgreement svcType={TERMS_TYPE.AGREEMENT} ref={submitButton} onValidationChange={handleValidationChange} />
        );
        break;
      default:
        getComponent = <ErrorTemplate refTitle="Page Not Found" askBtn refCode="404" service="Employee" />;
        break;
    }

    return (
      <>
        <BrityHeader />
        <div className="brity-container">
          <div className="brity-contents">
            <PageHeader titleSvcType={titleSvcType} />
            <div className="brity-content-area">
              <div className="form-wrap">
                {getComponent}
                <div className="btn-set al-right">
                  <Button
                    componentType="solid"
                    className="primary "
                    label={i18n.t('EM_T_TERMS_SAVE')}
                    onClick={() => {
                      termsHandleSave();
                    }}
                    disabled={!isFormValid}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <BrityFooter isAdmin={menu === 'admin'} />
      </>
    );
  };

  return (
    <>
      {termsIsSuccess || inviteChange || instantCreate || adminCreate ? (
        <Compltion svcType={svcType} />
      ) : (
        isLoad && makeComponent()
      )}
    </>
  );
};

IncorporationOfTerms.propTypes = {};
IncorporationOfTerms.defaultProps = {};
export default IncorporationOfTerms;
